export default class DtoLocation {
    constructor(obj) {
        this.x = obj.x
        this.y = obj.y
        this.projection = obj.projection
    }
}